// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"style_subtitle__381Xw"};